
//import { AGORA_APP_ID } from "@/views/Player/agora.config";
//import db from "@/components/firebaseInit";
import AgoraRTM from 'agora-rtm-sdk'

let vm;
export default {
	channelName: "",
	uid: "",
	recipientId: "",
	//appId: AGORA_APP_ID,
	rtm_client: AgoraRTM.createInstance("4b88772b431645288736acca1a8dd087"),
	rtm_channel: null,

	initRTM(channelName, uid, recipientId) {
		vm = this;
		vm.channelName = channelName;
		vm.uid = uid;
		vm.recipientId = recipientId;
		if (vm.channelName != "") {
			if (vm.rtm_client != undefined) {
				vm.InitAgoraRTMClient();
				if (vm.rtm_channel == undefined) {
					//vm.rtm_channel = vm.rtm_client.createChannel(vm.channelName);
					//vm.InitAgoraRTMChannel();
					vm.AgoraClientLogin();
				}
			}
		}
	},

	InitAgoraRTMClient() {
		if (vm.rtm_client != undefined) {
			vm.rtm_client.on('ConnectionStateChange', (newState, reason) => {
				console.log('on connection state changed to ' + newState + ' reason: ' + reason);
			});

			// event listener for receiving a peer-to-peer message.
			vm.rtm_client.on('MessageFromPeer', ({ text }, peerId) => {
				//alert(peerId + ":" + text);
				// text: text of the received message; peerId: User ID of the sender.
				//$("#chat_list").append("<div class='left chat-msg'>" + text + "</div>");
				console.log('AgoraRTM msg from user ' + peerId + ' recieved: \n' + text);
			});
		}
	},

	//InitAgoraRTMChannel() {
	//	if (vm.rtm_channel != undefined) {
	//		vm.rtm_channel.on('MemberJoined', (memberId) => {
	//			//alert("MemberJoined:" + memberId);
	//			vm.addAttendee(memberId)
	//		});
	//		vm.rtm_channel.on('MemberLeft', (memberId) => {
	//			//alert("MemberLeft:" + memberId);
	//			vm.removeAttendee(memberId)
	//			//vm.currentAttendeeCount--;
	//			//vm.currentAttendeeCount = vm.getMemberCount();
	//		});
	//	}
	//},

	AgoraClientLogin() {
		if (vm.uid != "") {
			let tkn = null;
			if (vm.rtm_client == undefined)
				return;
			vm.rtm_client.login({ token: tkn, uid: vm.channelName + "_" + vm.uid.toString() }).then(() => {
				console.log('AgoraRTM client login success');
				if (vm.rtm_channel != undefined) {
					//vm.JoinRTMChannel();
				}
				else {
					console.log('failed to join channel for error: Channel is not initialized.');
				}
			}).catch(err => {
				console.log('AgoraRTM client login failure', err);
			});
		}
	},

	//JoinRTMChannel() {
	//	if (vm.rtm_channel == undefined)
	//		return;
	//	vm.rtm_channel.join().then(() => {
	//		//alert();
	//		debugger
	//		//vm.addAttendee(vm.uid);
	//		//vm.getPreviouslyJouinedMembers();
	//	}).catch(error => {
	//		console.log('failed to join channel for error: ' + error);
	//	});
	//},

	//LeaveRTMChannel() {
	//	if (vm.rtm_channel == undefined)
	//		return;
	//	vm.rtm_channel.leave().then(() => {
	//		//remove Attendee
	//		//vm.removeAttendee(vm.uid)
	//		//vm.currentAttendeeCount--;
	//		//vm.currentAttendeeCount = vm.getMemberCount();
	//		//vm.getPreviouslyJouinedMembers();
	//	}).catch(error => {
	//		console.log('failed to join channel for error: ' + error);
	//	});
	//},

	sendP2PMessage(m) {
		// An RtmMessage object.
		const msg = {
			description: undefined,
			messageType: 'TEXT',
			rawMessage: undefined,
			text: m
		}
		const recipient = vm.recipientId;// The user ID of the remote user.
		//const recipient = "221001" // The user ID of the remote user.
		const options = { enableHistoricalMessaging: true, enableOfflineMessaging: false }

		// p2p message
		vm.rtm_client.sendMessageToPeer(msg, recipient, options).then(sendResult => {
			if (sendResult.hasPeerReceived) {
				//alert("Received")
				//$("#chat_list").append("<div class='right chat-msg'>" + msg.text + "</div>");
				/* Your code for handling the event that the remote user receives the message. */
			} else {
				/* Your code for handling the event that the message is received by the server but the remote user cannot be reached. */
			}
		}).catch(error => {
			console.log('failed to sendMessageToPeer for error: ' + error);
			/* Your code for handling the event of a message send failure. */
		});
	},
};